import { render, staticRenderFns } from "./UsersCreateWindow.vue?vue&type=template&id=a1890fe4&"
import script from "./UsersCreateWindow.vue?vue&type=script&lang=ts&"
export * from "./UsersCreateWindow.vue?vue&type=script&lang=ts&"
import style0 from "./UsersCreateWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports